/* eslint-disable import/prefer-default-export */
import { ofType } from "redux-observable"
import { from, of } from "rxjs"
import { catchError, delay, map, mergeMap, switchMap } from "rxjs/operators"
import CalendarUtils from "../../lib/CalendarUtils"
import {
  hideError,
  saveDataForDomain,
  setMelList,
  setMelTemplateList,
  unsetFormValidationFailed,
} from "../actions/application"
import { setDayWidth } from "../actions/calendar"
import { setViewFilterToStoredVersion } from "../actions/filters"
import { getMessagesListForUser } from "../actions/managecontent"
import { observerError } from "../actions/observer"
import { editRequestComplete } from "../actions/requests"
import { fetchRigData } from "../actions/schedulerData"
import { fetchUserRightsAndRoles } from "../actions/user"
import * as types from "../types"

import Api from "../../services/ApiService"

const getArrayData = (result) => {
  if (Array.isArray(result)) {
    return result
  }
  if (Array.isArray(result?.data)) {
    return result.data
  }
  if (Array.isArray(result?.data?.data)) {
    return result.data.data
  }
  return []
}

export const getSettingsForDomain = (action$) =>
  action$.pipe(
    ofType(types.GET_DOMAIN_DATA),
    switchMap(() =>
      from(
        Api.getDataFromApi("appSettings")
        // Api.getSettingsDummy(),
      ).pipe(catchError((err) => of(observerError(err.xhr.response))))
    ),
    // tap(result => console.log('rr::::', result)),
    mergeMap((result) => [
      // mergeMap(result => [
      saveDataForDomain(result),
      fetchUserRightsAndRoles(),
      fetchRigData(),
      getMessagesListForUser(),
      setViewFilterToStoredVersion(),
    ])
  )
export const getMelTemplateList = (action$) =>
  action$.pipe(
    ofType(types.GET_MEL_TEMPLATE_LIST),
    switchMap(() =>
      from(Api.getDataFromApi("appSettings/melTemplates")).pipe(
        catchError((err) => of(observerError(err.xhr.response)))
      )
    ),
    mergeMap((result) => [setMelTemplateList(getArrayData(result))])
  )
export const getMelList = (action$) =>
  action$.pipe(
    ofType(types.GET_MEL_LIST),
    switchMap(() =>
      from(Api.getDataFromApi("mel")).pipe(
        catchError((err) => of(observerError(err.xhr.response)))
      )
    ),
    mergeMap((result) => [setMelList(getArrayData(result))])
  )
/**
  UPDATE DAY WIDTH
*/
export const updateDayWidthAfterResize = (action$, state$) =>
  action$.pipe(
    ofType(types.RESIZE),
    switchMap(() =>
      from(
        CalendarUtils.updateDayWidth(
          state$.value.calendar.zoomLevel,
          state$.value.application.size.width,
          state$.value.calendar.timespan
        )
      ).pipe(catchError((err) => of(observerError(err.xhr.response))))
    ),
    map((result) => setDayWidth(result))
  )

export const onClosePanel = (action$) =>
  action$.pipe(
    ofType(types.CLOSE_PANEL),
    map((result) => editRequestComplete(result))
  )

export const hideErrorAfterDelay = (action$) =>
  action$.pipe(
    ofType(types.THROW_ERROR),
    delay(3000),
    map(() => hideError())
  )

export const unsetModalFailedValidation = (action$) =>
  action$.pipe(
    ofType(types.SET_MODAL_FAILED_VALIDATION),
    delay(2000),
    map(() => unsetFormValidationFailed())
  )
